import React from 'react';
import './Pay.css'

const Pay = () => {
    return (
        <div className="pay-container">
            <h2>Payment System is comming soon</h2>
        </div>
    );
};

export default Pay;